import { useState } from 'react';
import { postLoginService, postCheckUsernameSso } from '../services';

const LOGIN_BODY_DEFAULT = {
  identity: null,
  password: null,
  dealer_id: '',
};

export default function useLogin(dealerId, setError, csrfToken) {
  const [loginBody, setLoginBody] = useState(LOGIN_BODY_DEFAULT);

  async function postLogin() {
    setError('');
    try {
      const checkSsoResp = await postCheckUsernameSso(
        csrfToken,
        loginBody.identity,
      );
      const parsedCheckSsoResp = await checkSsoResp.json();

      if (parsedCheckSsoResp.allow_password_login) {
        const response = await postLoginService(csrfToken, {
          ...loginBody,
          dealer_id: dealerId,
        });

        const parsedResponse = await response.json();
        window.location.href = parsedResponse.return_to || '/';
      } else if (parsedCheckSsoResp.requires_sso) {
        window.location.href = parsedCheckSsoResp.redirect_url || '/';
      }
    } catch (error) {
      setError(error);
    }
  }

  function isDirty() {
    return !(loginBody.identity && loginBody.password);
  }

  return {
    loginBody,
    setLoginBody,
    postLogin,
    isDirty,
  };
}
